import { Controller } from "@hotwired/stimulus";
import { createRoot, type Root } from "react-dom/client";
import React from "react";

import CreateAccountForm from "src/customer/create_account_form";
import { rootPath } from "src/routes";

export default class extends Controller {
  private root?: Root;

  connect() {
    this.root = createRoot(this.element);

    this.root.render(this.createAccountComponent())
  }

  disconnect() {
    if (this.root) {
      this.root.unmount();
      this.root = undefined;
    }
  }

  private createAccountComponent() {
    return React.createElement(
      CreateAccountForm, {
        afterCreateAccountCallback: () => { window.location.assign(rootPath()) },
        hasStickyHeader: true,
      }
    );
  }
}
